import {
  GET_ALL_LEAVE_REQUEST,
  GET_ALL_LEAVE_SUCCESS,
  GET_ALL_LEAVE_FAIL,
} from "../../types/admin/allLeavesTypes";

export const getAllLeaveReducer = (state = { notifications: [] }, action) => {
  switch (action.type) {
    case GET_ALL_LEAVE_REQUEST:
      return { loading: true, notifications: [] };

    case GET_ALL_LEAVE_SUCCESS:
      return { loading: false, notifications: action.payload };

    case GET_ALL_LEAVE_FAIL:
      return { loading: false, error: action.payload };

    default:
      return state;
  }
};
